export default __webpack_public_path__ + "9742174541d6ec82199d3ee8401c5482.png";